import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { Modal, Dropdown, DropdownButton } from 'react-bootstrap'
import Select from 'react-select'

import FilterSearch from 'pages/parts/FilterSearch'
import useFilterSearchPagination from 'pages/parts/useFilterSearchPagination'

import { httpOk, POST, PUT, GET, FILE } from 'helpers/api'
import { findKeyFromArrayByValue, notify, regexPhoneNumber, returnSign } from 'helpers/helpers'
import { renderSortIndicator, patchSortFilterOnColumnClick, renderSortDirectionIcon } from 'helpers/tableSortIndicator'
import QuickSupplierModal from './QuickSupplierModal'

function Index() {
	const { t } = useTranslation()

	const statuses = [
		{ 'id': 1, 'name': t('success') },
		{ 'id': -1, 'name': t('deleted') }
	]

	const [supplierTypes, setSupplierTypes] = useState([])
	const [showModal, setShowModal] = useState(false)
	const [quickCreateModal, setQuickCreateModal] = useState(false)
	const [activeTab, setActiveTab] = useState('personal')
	const {
		filterData,
		appliedFilterData,
		setAppliedFilterData,
		filterDataExist,
		setFilterDataExist,
		patchFilterData,
		applySearch,
		applyFilters,
		resetToInitialFilters,
	} = useFilterSearchPagination({
		initialFilterData: {
			status: 1,
			supplier_type_id: null,
			search: '',
			order_by: null,
			sort: 'asc',
		},
		initialPagination: {
			url: '/suppliers',
			response: null,
		},
	})
	const [modalDelete, setModalDelete] = useState(false)
	const [modalRestore, setModalRestore] = useState(false)
	const [selectedItem, setSelectedItem] = useState({})
	const [dropdownIsOpen, setDropdownIsOpen] = useState(false)
	const [data, setData] = useState([])

	async function searchWithFilter(passedData = {}) {
		var filterDataCopy = { ...filterData, ...(passedData.filterData || {}) }
		var filterUrl = "/suppliers"
		var urlParams = ""
		checkFilter(filterDataCopy)

		if (filterDataCopy.supplier_type_id)
			urlParams += returnSign(urlParams) + 'supplier_type_id=' + filterDataCopy.supplier_type_id
		if (filterDataCopy.status)
			urlParams += returnSign(urlParams) + 'status=' + filterDataCopy.status
		if (filterDataCopy.search)
			urlParams += returnSign(urlParams) + 'search=' + filterDataCopy.search
		if (filterDataCopy.order_by) {
			urlParams += returnSign(urlParams) + 'order_by=' + filterDataCopy.order_by
			urlParams += returnSign(urlParams) + 'sort=' + (filterDataCopy.sort === 'desc' ? 'desc' : 'asc')
		}

		if (`/suppliers${urlParams}` !== filterUrl)
			setFilterDataExist(true)

		filterUrl = filterUrl + urlParams

		const response = await GET(filterUrl, {}, { loader: true })
		if (httpOk(response)) {
			setData(response.data)
			setAppliedFilterData(filterDataCopy)
		}

		setDropdownIsOpen(false)
	}

	async function createUpdate() {
		var response;
		if (selectedItem.id) {
			response = await PUT('/suppliers', selectedItem, { loader: true })
		} else {
			response = await POST('/suppliers', selectedItem, { loader: true })
		}

		if (httpOk(response)) {
			searchWithFilter()
			toggleModal()
		}
	}

	async function deleteItem(e) {
		e.preventDefault()

		var sendData = { ...selectedItem }
		sendData.status = -1
		var response = await PUT('/suppliers-status', sendData, { loader: true })

		if (httpOk(response)) {
			searchWithFilter()
			toggleModalDelete(false)
		}
	}

	async function restoreItem(e) {
		e.preventDefault();
		var sendData = { ...selectedItem }

		sendData.status = 1
		var response = await PUT('/suppliers-status', sendData, { loader: true })

		if (httpOk(response)) {
			searchWithFilter()
			toggleModalRestore(false)
		}
	}

	async function importFromExel(e) {
		let formData = new FormData();
		formData.append("file", e.target.files[0]);

		var response = await FILE('/suppliers-excel-import', formData, {}, { loader: true });

		if (httpOk(response)) {
			notify(t('success'), 'success')
			searchWithFilter()
		}

		document.getElementById('actual-btn').value = '';
	}

	function resetFilter() {
		resetToInitialFilters((nextFilterData) => {
			searchWithFilter({
				filterData: {
					...nextFilterData,
					status: 1,
					order_by: null,
					sort: 'asc',
				}
			})
		})
	}

	function handleSuppliersNameSort() {
		const next = patchSortFilterOnColumnClick(filterData, 'name')
		patchFilterData({ order_by: next.order_by, sort: next.sort })
		searchWithFilter({ filterData: next })
	}

	function checkFilter(currentFilterData) {
		if (
			currentFilterData.search === ''
		) {
			setFilterDataExist(false)
		}
	}

	function toggleDropdown() {
		setDropdownIsOpen(!dropdownIsOpen)
	}

	function toggleModal(bool = false, item = {}) {
		setActiveTab('personal')
		setSelectedItem(item)
		setShowModal(bool)
	}

	function toggleModalDelete(bool = false, item = {}) {
		setSelectedItem(item)
		setModalDelete(bool)
	}

	function toggleModalRestore(bool = false, item = {}) {
		setSelectedItem(item)
		setModalRestore(bool)
	}

	async function getSupplierTypes() {
		const response = await GET('/helper/supplier-types')
		if (httpOk(response)) setSupplierTypes(response.data)
	}

	useEffect(() => {
		getSupplierTypes()
		searchWithFilter()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	const supplierNameSortState = { order_by: filterData.order_by, sort: filterData.sort }

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center">
					{t('suppliers')} [{data.total}]
				</h4>
				<div className="d-flex gap-2">
					<button className="btn-rounded btn btn-primary"
						onClick={() => setQuickCreateModal(true)}>
						{t('create')}
					</button>
					<DropdownButton title={t('action')}>
						<Dropdown.Item as="li" eventKey="1">
							<input id="actual-btn" hidden type="file" onChange={importFromExel} accept=".xlsx, application/vnd.ms-excel" />
							<label htmlFor="actual-btn" className="upload-from-excel">{t('import')}</label>
						</Dropdown.Item>
						<Dropdown.Item as="li" eventKey="2">
							<a href={`${process.env.REACT_APP_DOWNLOAD_DOMAIN}/files/suppliers_template.xlsx`} className="upload-from-excel">
								{t('download_template')}
							</a>
						</Dropdown.Item>
					</DropdownButton>
				</div>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="d-flex flex-wrap mb-3">
						<div className="d-flex flex-wrap gap-2">
							<div>
								<FilterSearch
									value={filterData.search}
									onSearchChange={(search) => applySearch(search, (nextFilterData) => {
										searchWithFilter({ filterData: nextFilterData })
									})}>
								</FilterSearch>
							</div>
							<div>
								<Dropdown onToggle={toggleDropdown} show={dropdownIsOpen}>
									<Dropdown.Toggle variant="outline-primary" className="btn-wide h-100">
										{t('filter')}
									</Dropdown.Toggle>

									<Dropdown.Menu className="dropdown-filter">
										<div className="row">
											<div className="form-group col-md-6">
												<label>{t('type')}</label>
												<Select
													isClearable
													options={supplierTypes}
													value={supplierTypes.find(option => option.id === filterData.supplier_type_id) || ''}
													onChange={(option) => patchFilterData({ 'supplier_type_id': option ? option.id : null })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
											<div className="form-group col-md-6">
												<label>{t('status')}</label>
												<Select
													options={statuses}
													value={statuses.find(option => option.id === filterData.status) || ''}
													onChange={(option) => patchFilterData({ 'status': option.id })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
										</div>

										<div className="row mt-3">
											<div className="col-md-12">
												<div className="d-flex justify-content-end gap-2">
													<button className="btn btn-secondary"
														onClick={() => setDropdownIsOpen(false)}>
														{t('cancel')}
													</button>
													<button className="btn btn-primary"
														onClick={() => applyFilters((nextFilterData) => {
															searchWithFilter({ filterData: nextFilterData })
														})}>
														{t('apply')}
													</button>
												</div>
											</div>
										</div>
									</Dropdown.Menu>
								</Dropdown>
							</div>
						</div>
					</div>

					{filterDataExist &&
						<div className="filter-block">
							<div className="filter">
								<strong>{t('filter')}</strong>
								<br />
								{appliedFilterData.status &&
									<span className="me-2">
										<b>{t('status')}: </b>
										{findKeyFromArrayByValue(statuses, 'id', appliedFilterData.status, 'name')}
									</span>
								}
								{appliedFilterData.supplier_type_id &&
									<span className="me-2">
										<b>{t('type')}: </b>
										{findKeyFromArrayByValue(supplierTypes, 'id', appliedFilterData.supplier_type_id, 'name')}
									</span>
								}
								{appliedFilterData.search &&
									<span className="me-2">
										<b>{t('search')}: </b>
										<span>{appliedFilterData.search}</span>
									</span>
								}
								{appliedFilterData.order_by &&
									<span className="me-2 d-inline-flex align-items-center flex-wrap gap-1">
										<b>{t('sort_by')}: </b>
										<span className="d-inline-flex align-items-center gap-1">
											{t('name2')}
											{renderSortDirectionIcon(appliedFilterData.sort === 'desc' ? 'desc' : 'asc', {
												ariaLabel: appliedFilterData.sort === 'desc' ? t('sort_descending') : t('sort_ascending'),
												title: appliedFilterData.sort === 'desc' ? t('sort_descending') : t('sort_ascending'),
											})}
										</span>
									</span>
								}
							</div>
							<div className="vertical-center">
								<button className="btn btn-outline-dark text-uppercase" onClick={resetFilter}>{t('reset')}</button>
							</div>
						</div>
					}

					<div className="table-responsive">
						<table className="table table-bordered table-hover mb-0">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th
										style={{ width: '20%' }}
										className="th-sortable user-select-none"
										onClick={handleSuppliersNameSort}
										title={t('sort_by')}>
										<div className="d-flex align-items-center justify-content-between gap-2 pe-1">
											<span>{t('name2')}</span>
											{renderSortIndicator('name', supplierNameSortState)}
										</div>
									</th>
									<th style={{ 'minWidth': '130px' }}>{t('phone')}</th>
									<th style={{ 'minWidth': '130px' }}>{t('type')}</th>
									<th style={{ 'minWidth': '130px' }}>{t('tin')}</th>
									<th style={{ 'width': '10%' }} className="td-ellipsis">{t('internal_supplier')}</th>
									<th style={{ 'width': '10%' }}>{t('deleted_by')}</th>
									<th style={{ 'width': '45%' }}></th>
									<th style={{ 'minWidth': '33px' }}></th>
								</tr>
							</thead>
							<tbody>
								{data?.data?.map((item, index) => (
									<tr key={index}>
										<td className="text-center">
											{item.row_number}
										</td>
										<td className="td-ellipsis" title={item.name}>
											<span className="link-primary" style={{ 'cursor': 'pointer' }}
												onClick={() => toggleModal(true, item)}>{item.name}</span>
										</td>
										<td>{regexPhoneNumber(item.phone)}</td>
										<td>{item.supplier_type_name}</td>
										<td>{item.tin}</td>
										<td className={item.is_internal ? 'bg-primary' : 'bg-danger'}></td>
										<td title={item.deleted_by}>{item.deleted_name}</td>
										<th></th>
										<td>
											<div className="table-dropdown">
												<Dropdown id={`dropdown-${index}`}>
													<Dropdown.Toggle variant="outline-primary">
														<i className="uil uil-ellipsis-v"></i>
													</Dropdown.Toggle>

													<Dropdown.Menu>
														<div className="table-dropdown-item"
															onClick={() => toggleModal(true, item)}>
															<i className="uil-edit-alt"></i>
															{t('edit')}
														</div>
														{item.status === 1 &&
															<div className="table-dropdown-item text-danger"
																onClick={() => toggleModalDelete(true, item)}>
																<i className="uil-times"></i>
																{t('delete')}
															</div>
														}
														{item.status === -1 &&
															<div className="table-dropdown-item text-success"
																onClick={() => toggleModalRestore(true, item)}>
																<i className="uil-history-alt"></i>
																{t('restore')}
															</div>
														}
													</Dropdown.Menu>
												</Dropdown>
											</div>
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				</div>
			</div>

			{/* MODAL */}
			<Modal show={showModal} animation={false} centered size="lg"
 onHide={() => toggleModal()}>
				<Modal.Header closeButton>
					<Modal.Title>
						{selectedItem.id ?
							<>{t('edit')}</>
							:
							<>{t('create')}</>
						}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body className="p-0">
					<ul className="nav nav-tabs">
						<li className="nav-item" onClick={() => setActiveTab('personal')}>
							<span className={`nav-link ${activeTab === 'personal' ? 'active ' : ''}`}>{t('main')}</span>
						</li>
						<li className="nav-item" onClick={() => setActiveTab('legal')}>
							<span className={`nav-link ${activeTab === 'legal' ? 'active ' : ''}`}>{t('legal_entity')}</span>
						</li>
					</ul>
					<form onSubmit={createUpdate} autoComplete="off" className="p-3" style={{ 'height': '500px', 'overflow': 'auto' }}>
						{activeTab === 'personal' &&
							<>
								<div className="d-flex gap-2">
									<div style={{ 'width': '33%' }}>
										<div className="form-group">
											<label>{t('system_name')}<span className="required-mark">*</span></label>
											<input type="text" className="form-control" name="name"
												value={selectedItem.name ?? ''}
												onChange={(e) => setSelectedItem({ ...selectedItem, 'name': e.target.value })} />
										</div>
										<div className="form-group">
											<label>{t('phone')}</label>
											<input type="number" className="form-control" name="phone"
												value={selectedItem.phone ?? ''}
												onChange={(e) => setSelectedItem({ ...selectedItem, 'phone': e.target.value })} />
										</div>
										<div className="form-group">
											<label>{t('name')}</label>
											<input type="text" className="form-control" name="first_name"
												value={selectedItem.first_name ?? ''}
												onChange={(e) => setSelectedItem({ ...selectedItem, 'first_name': e.target.value })} />
										</div>
										<div className="form-group">
											<label>{t('surname')}</label>
											<input type="text" className="form-control" name="last_name"
												value={selectedItem.last_name ?? ''}
												onChange={(e) => setSelectedItem({ ...selectedItem, 'last_name': e.target.value })} />
										</div>
										<div className="form-group">
											<label>{t('gender')}</label>
											<Select
												isClearable
												options={[
													{ "id": 1, "name": t('man') },
													{ "id": 2, "name": t('woman') }
												]}
												value={[
													{ "id": 1, "name": t('man') },
													{ "id": 2, "name": t('woman') }
												].find(option => option.id === selectedItem.gender)}
												onChange={(option) => setSelectedItem({ ...selectedItem, 'gender': option ? option.id : null })}
												placeholder=""
												noOptionsMessage={() => t('list_empty')}
												getOptionLabel={(option) => option.name}
												getOptionValue={(option) => option.id}
											/>
										</div>
									</div>
									<div style={{ 'width': '33%' }}>
										<div className="form-group">
											<label>{t('type')}</label>
											<Select
												isClearable
												options={supplierTypes}
												value={supplierTypes.find(option => option.id === selectedItem.supplier_type_id) || ''}
												onChange={(option) => setSelectedItem({ ...selectedItem, 'supplier_type_id': option ? option.id : null })}
												placeholder=""
												noOptionsMessage={() => t('list_empty')}
												getOptionLabel={(option) => option.name}
												getOptionValue={(option) => option.id}
											/>
										</div>
										<div className="form-group">
											<label>{t('company')}</label>
											<input type="text" className="form-control" name="company_name"
												value={selectedItem.company_name ?? ''}
												onChange={(e) => setSelectedItem({ ...selectedItem, 'company_name': e.target.value })} />
										</div>
										<div className="form-group">
											<label>{t('mobile')}</label>
											<input type="text" className="form-control" name="mobile_phone"
												value={selectedItem.mobile_phone ?? ''}
												onChange={(e) => setSelectedItem({ ...selectedItem, 'mobile_phone': e.target.value })} />
										</div>
										<div className="form-group">
											<label>E-mail</label>
											<input type="text" className="form-control" name="email"
												value={selectedItem.email ?? ''}
												onChange={(e) => setSelectedItem({ ...selectedItem, 'email': e.target.value })} />
										</div>
										<div className="form-group">
											<label>{t('birthday')}</label>
											<input type="date" className="form-control" name="birthday"
												value={selectedItem.birthday ?? ''}
												onChange={(e) => setSelectedItem({ ...selectedItem, 'birthday': e.target.value })} />
										</div>
									</div>
								</div>
								<div className="d-flex justify-content-between mb-2">
									<p className="fw-600 vertical-center">{t('internal_supplier')}</p>
									<div className="form-check form-switch form-switch-lg">
										<input type="checkbox" className="form-check-input" name="is_internal"
											checked={selectedItem?.is_internal ?? false}
											onChange={(e) => setSelectedItem({ ...selectedItem, 'is_internal': e.target.checked })} />
									</div>
								</div>
								<div className="d-flex justify-content-between mb-2">
									<p className="fw-600 vertical-center">{t('internal_settlement')}</p>
									<div className="form-check form-switch form-switch-lg">
										<input type="checkbox" className="form-check-input" name="internal_settlement"
											checked={selectedItem?.internal_settlement ?? false}
											onChange={(e) => setSelectedItem({ ...selectedItem, 'internal_settlement': e.target.checked })} />
									</div>
								</div>
							</>
						}
						{activeTab === 'legal' &&
							<div className="d-flex gap-2">
								<div style={{ 'width': '50%' }}>
									<div className="form-group">
										<label>Краткое наим</label>
										<input type="text" className="form-control" name="short_name"
											value={selectedItem.short_name ?? ''}
											onChange={(e) => setSelectedItem({ ...selectedItem, 'short_name': e.target.value })} />
									</div>
									<div className="form-group">
										<label>Полное наим</label>
										<input type="text" className="form-control" name="full_name"
											value={selectedItem.full_name ?? ''}
											onChange={(e) => setSelectedItem({ ...selectedItem, 'full_name': e.target.value })} />
									</div>
									<div className="form-group">
										<label>Телефон</label>
										<input type="text" className="form-control" name="legal_phone"
											value={selectedItem.legal_phone ?? ''}
											onChange={(e) => setSelectedItem({ ...selectedItem, 'legal_phone': e.target.value })} />
									</div>
									<div className="d-flex gap-2">
										<div className="form-group">
											<label>ИНН</label>
											<input type="text" className="form-control" name="tin"
												value={selectedItem.tin ?? ''}
												onChange={(e) => setSelectedItem({ ...selectedItem, 'tin': e.target.value })} />
										</div>
										<div className="form-group">
											<label>Банк</label>
											<input type="text" className="form-control" name="bank_name"
												value={selectedItem.bank_name ?? ''}
												onChange={(e) => setSelectedItem({ ...selectedItem, 'bank_name': e.target.value })} />
										</div>
									</div>
									<div className="d-flex gap-2">
										<div className="form-group">
											<label>КПП</label>
											<input type="text" className="form-control" name="kpp"
												value={selectedItem.kpp ?? ''}
												onChange={(e) => setSelectedItem({ ...selectedItem, 'kpp': e.target.value })} />
										</div>
										<div className="form-group">
											<label>Город банка</label>
											<input type="text" className="form-control" name="bank_city"
												value={selectedItem.bank_city ?? ''}
												onChange={(e) => setSelectedItem({ ...selectedItem, 'bank_city': e.target.value })} />
										</div>
									</div>
									<div className="d-flex gap-2">
										<div className="form-group">
											<label>GLN</label>
											<input type="text" className="form-control" name="gln"
												value={selectedItem.gln ?? ''}
												onChange={(e) => setSelectedItem({ ...selectedItem, 'gln': e.target.value })} />
										</div>
										<div className="form-group">
											<label>Бик</label>
											<input type="text" className="form-control" name="bic"
												value={selectedItem.bic ?? ''}
												onChange={(e) => setSelectedItem({ ...selectedItem, 'bic': e.target.value })} />
										</div>
									</div>
									<div className="d-flex gap-2">
										<div className="form-group">
											<label>ОКПО</label>
											<input type="text" className="form-control" name="okpo"
												value={selectedItem.okpo ?? ''}
												onChange={(e) => setSelectedItem({ ...selectedItem, 'okpo': e.target.value })} />
										</div>
										<div className="form-group">
											<label>Расч. счет</label>
											<input type="text" className="form-control" name="account_number"
												value={selectedItem.account_number ?? ''}
												onChange={(e) => setSelectedItem({ ...selectedItem, 'account_number': e.target.value })} />
										</div>
									</div>
									<div className="d-flex gap-2">
										<div className="form-group">
											<label>ОКДП</label>
											<input type="text" className="form-control" name="okdp"
												value={selectedItem.okdp ?? ''}
												onChange={(e) => setSelectedItem({ ...selectedItem, 'okdp': e.target.value })} />
										</div>
										<div className="form-group">
											<label>Корр. счет</label>
											<input type="text" className="form-control" name="correspondent_account"
												value={selectedItem.correspondent_account ?? ''}
												onChange={(e) => setSelectedItem({ ...selectedItem, 'correspondent_account': e.target.value })} />
										</div>
									</div>
									<div className="form-group">
										<label>IBAN</label>
										<input type="text" className="form-control" name="iban"
											value={selectedItem.iban ?? ''}
											onChange={(e) => setSelectedItem({ ...selectedItem, 'iban': e.target.value })} />
									</div>
									<div className="d-flex gap-2">
										<div className="form-group">
											<label>SWIFT BIC</label>
											<input type="text" className="form-control" name="swift_bic"
												value={selectedItem.swift_bic ?? ''}
												onChange={(e) => setSelectedItem({ ...selectedItem, 'swift_bic': e.target.value })} />
										</div>
										<div className="form-group">
											<label>Рег. номер</label>
											<input type="text" className="form-control" name="reg_number"
												value={selectedItem.reg_number ?? ''}
												onChange={(e) => setSelectedItem({ ...selectedItem, 'reg_number': e.target.value })} />
										</div>
									</div>
									<div className="form-group">
										<label>Юр. адрес</label>
										<input type="text" className="form-control" name="legal_address"
											value={selectedItem.legal_address ?? ''}
											onChange={(e) => setSelectedItem({ ...selectedItem, 'legal_address': e.target.value })} />
									</div>
									<div className="form-group">
										<label>Факт. адрес</label>
										<input type="text" className="form-control" name="actual_address"
											value={selectedItem.actual_address ?? ''}
											onChange={(e) => setSelectedItem({ ...selectedItem, 'actual_address': e.target.value })} />
									</div>
								</div>
							</div>
						}
					</form>
				</Modal.Body>
				<Modal.Footer >
					<div className="d-flex gap-2 w-100 mt-3">
						<button type="button" className="btn btn-outline-warning w-100"
							onClick={() => toggleModal()}>
							{t('cancel')}
						</button>
						<button type="button" className="btn btn-primary w-100"
							onClick={() => createUpdate()}>
							{t('save')}
						</button>
					</div>
				</Modal.Footer>
			</Modal>
			{/* MODAL */}

			<QuickSupplierModal
				show={quickCreateModal}
				onClose={() => setQuickCreateModal(false)}
				onCreated={() => searchWithFilter()}>
			</QuickSupplierModal>

			{/* MODAL DELETE */}
			<Modal show={modalDelete} animation={false} centered dialogClassName="update-modal-width"
 onHide={() => toggleModalDelete()}>
				<Modal.Header closeButton>
					<Modal.Title>
						{t('delete')}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={deleteItem} autoComplete="off">
						<h4>
							{t('are_you_sure_you_want_delete')}
						</h4>
						<h6 className="text-danger">
							{t('delete_text')}.
						</h6>
						<div className="d-flex gap-2 w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100"
								onClick={() => toggleModalDelete()}>
								{t('cancel')}
							</button>
							<button type="submit" className="btn btn-primary w-100">{t('save')}</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL DELETE */}

			{/* MODAL RESTORE */}
			<Modal show={modalRestore} animation={false} centered dialogClassName="update-modal-width"
 onHide={() => toggleModalRestore()}>
				<Modal.Header closeButton>
					<Modal.Title>
						{t('restore')}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={(e) => restoreItem(e)} autoComplete="off">
						<h5>
							{t('are_you_sure_you_want')} <b>{t('restore')}</b>
						</h5>
						<div className="d-flex gap-2 w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100"
								onClick={() => toggleModalRestore()}>
								{t('cancel')}
							</button>
							<button type="submit" className="btn btn-success w-100">{t('confirm')}</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL RESTORE */}
		</>
	)
}

export default Index
